<template>
  <div>
    <InputDecimal
      :name="name"
      :fraction-min="0"
      :fraction-max="fractionMaxValue"
      :model-value="percentage"
      :fraction-decimals="decimals"
      :min="min"
      max="100"
      decimal-point="."
      fraction-placeholder="00"
      :data-test-prefix="dataTestPrefix"
      @update:model-value="update"
    >
      <template #before-integer>
        <span class="input-group-addon">%</span>
      </template>
    </InputDecimal>
  </div>
</template>

<script>
import InputDecimal from '@/components/InputDecimal.vue'

export default {
  components: {
    InputDecimal,
  },
  props: {
    name: {
      type: String,
      default: 'percentage',
    },
    modelValue: {
      type: [String, Number],
      default: null,
    },
    initialValue: {
      type: [String, Number],
      default: null,
    },
    fractionMaxValue: {
      type: Number,
      default: 99,
    },
    decimals: {
      type: Number,
      default: 2,
    },
    min: {
      type: Number,
      default: 0,
    },
    dataTestPrefix: {
      type: String,
      default: null,
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      percentage: this.getInitialPercentageObject(),
    }
  },
  computed: {
    formattedValue() {
      return this.convertToString(this.percentage.integer, this.percentage.fraction)
    },
  },
  watch: {
    modelValue(newValue) {
      this.percentage = this.convertToIntegerFractionObject(newValue)
    },
  },
  methods: {
    update(value) {
      this.percentage.integer = value.integer
      this.percentage.fraction = value.fraction

      this.$emit('update:modelValue', this.formattedValue)
    },
    getInitialPercentageObject() {
      return this.convertToIntegerFractionObject(this.initialValue || this.modelValue)
    },
    convertToString(integer, fraction) {
      return `${integer || 0}.${fraction || 0}`
    },
    convertToIntegerFractionObject(value) {
      let unformattedValue = value
      unformattedValue *= 1
      const [integer, fraction] = unformattedValue
        .toFixed(this.fractionMaxValue.toString().length)
        .toString()
        .split('.')
      return {
        integer,
        fraction,
      }
    },
  },
}
</script>
